import { Button, Flex, useBreakpointValue } from '@chakra-ui/react'
import { Speaker } from '@components/icons'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import { usePlaySound } from '../hooks/use-play-sound'

export const TestAudioButton = ({
  currentDevice
}: {
  currentDevice: string
}) => {
  const { playSound, isSoundPlaying, sounds } = usePlaySound()
  const isSmallScreen = useBreakpointValue({
    base: true,
    sm: false
  })
  const playTestSound = () => {
    playSound(sounds.TEST_SOUND, currentDevice)
  }

  return (
    <Flex
      h="48px"
      w="100%"
      borderRadius="24px"
      position="relative"
      bg="#F6F7FE"
      align="center"
      justify="center"
      overflow="hidden"
    >
      <AnimatePresence>
        {isSoundPlaying && (
          <motion.div
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{
              duration: 2.5,
              ease: 'easeInOut'
            }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              background: '#BFCBF7',
              zIndex: 0
            }}
          />
        )}
      </AnimatePresence>
      <Button
        bg="transparent"
        w="100%"
        onClick={playTestSound}
        color="primary"
        _focus={{
          outline: 'none'
        }}
        position="relative"
        size="lg"
        zIndex={1}
        leftIcon={<Speaker width="16px" fill="#2D54E8" />}
        data-click-text="Play test sound"
      >
        {isSoundPlaying
          ? 'Playing...'
          : isSmallScreen
            ? 'Test sound'
            : 'Play test sound'}
      </Button>
    </Flex>
  )
}
